import { memo, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';

import Image from 'next/image';

export const MonoTone = memo(function MonoTone({
  collection,
}: Readonly<{ collection: any }>) {
  const [isCollapsed, setIsCollapsed] = useState(true);

  return (
    <div className="mx-auto max-w-[800px] md:my-8">
      <div className="flex items-center justify-center gap-x-4">
        {collection.header_image && (
          <Image
            src={`${collection.header_image}`}
            alt={collection.title}
            unoptimized
            fill
            className="!relative !h-[40px] !w-auto"
          />
        )}
        <h1 className="font-header text-3xl font-bold">{collection.title}</h1>
      </div>
      {collection.description && (
        <div className="mx-auto mt-2 flex max-w-5xl flex-col items-center text-center">
          <div
            className={`${isCollapsed && 'line-clamp-3'}`}
            dangerouslySetInnerHTML={{ __html: collection.description }}
          />
          <button
            type="button"
            className="mt-2 flex items-center text-base font-normal text-bolt"
            onClick={() => setIsCollapsed(!isCollapsed)}
          >
            <span>{isCollapsed ? 'Read more' : 'Read less'}</span>
            <FontAwesomeIcon
              icon={faChevronUp}
              className={`ml-2 ${isCollapsed && 'rotate-180'}`}
            />
          </button>
        </div>
      )}
    </div>
  );
});
